import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { PlayerData } from '../../types/player';

interface DebugSectionProps {
  playerData: PlayerData;
  showHistoricalSearchDialog: boolean;
}

export const DebugSection: React.FC<DebugSectionProps> = ({ 
  playerData,
  showHistoricalSearchDialog
}) => {
  // Don't show in historical search dialog
  if (showHistoricalSearchDialog) {
    return null;
  }

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="debug" className="border-b border-gray-200 dark:border-gray-700">
        <AccordionTrigger className="px-4">
          <span>Debug: Full Response</span>
        </AccordionTrigger>
        <AccordionContent className="px-4">
          <div className="rounded bg-gray-50 dark:bg-gray-800 p-4">
            <pre className="font-mono text-sm whitespace-pre-wrap">
              {typeof playerData === 'object' && playerData !== null 
                ? JSON.stringify(playerData, null, 2)
                : String(playerData)
              }
            </pre>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};